export default {"src":"/_next/static/media/ecommerceLogo1.60dbc60f.svg","height":36,"width":84,"blurWidth":0,"blurHeight":0};